export const defaultPath = '/';
export const signInPath = '/sign-in';
export const dashboardPath = '/dashboard';
export const weatherPath = 'weather';
export const geoPath = 'geo';

export const weatherListUrl = `${dashboardPath}/${weatherPath}`;
export const geoListUrl = `${dashboardPath}/${geoPath}`;
export const weatherDetailUrl = (uuid: string) => `${weatherListUrl}/${uuid}`;
export const geoDetailUrl = (uuid: string) => `${geoListUrl}/${uuid}`;
